// AUTO-GENERATED — do not edit. Run `pnpm build` in packages/domain-data.
// Source: business/ishvaram/data/domain/astrology/planets.yaml

export interface Planet {
  /** Vedic id, e.g. "sun" */
  id: string;
  name_en: string;
  name_hi: string;
  name_sa: string;
  /** pyswisseph constant index */
  swisseph_id: number;
  nature: string;
  gender: string;
  element: string;
  /** rashi ids this planet rules */
  rules: string[];
  exaltation_sign: string;
  /** Absent for shadow planets (Rahu/Ketu) */
  exaltation_degree?: number;
  debilitation_sign: string;
  /** Absent for shadow planets (Rahu/Ketu) */
  debilitation_degree?: number;
  /** Absent for shadow planets (Rahu/Ketu) */
  moolatrikona_sign?: string;
  /** Absent for shadow planets (Rahu/Ketu) */
  moolatrikona_start?: number;
  /** Absent for shadow planets (Rahu/Ketu) */
  moolatrikona_end?: number;
  friends: string[];
  enemies: string[];
  neutrals: string[];
  signifies: string[];
  gemstone: string;
  metal: string;
  day: string;
  color: string;
  direction: string;
  /** true for Rahu and Ketu (shadow planets / lunar nodes) */
  is_shadow_planet?: boolean;
}

export const planets: readonly Planet[] = [
  {
    id: "sun",
    name_en: "Sun",
    name_hi: "सूर्य",
    name_sa: "Surya",
    swisseph_id: 0,
    nature: "malefic",
    gender: "male",
    element: "fire",
    rules: ["singh"],
    exaltation_sign: "mesh",
    exaltation_degree: 10,
    debilitation_sign: "tula",
    debilitation_degree: 190,
    moolatrikona_sign: "singh",
    moolatrikona_start: 120,
    moolatrikona_end: 140,
    friends: ["moon", "mars", "jupiter"],
    enemies: ["venus", "saturn"],
    neutrals: ["mercury"],
    signifies: ["soul", "father", "authority", "government", "health", "vitality", "ego"],
    gemstone: "ruby",
    metal: "gold",
    day: "sunday",
    color: "red",
    direction: "east",
  },
  {
    id: "moon",
    name_en: "Moon",
    name_hi: "चंद्र",
    name_sa: "Chandra",
    swisseph_id: 1,
    nature: "benefic",
    gender: "female",
    element: "water",
    rules: ["kark"],
    exaltation_sign: "vrishabh",
    exaltation_degree: 33,
    debilitation_sign: "vrishchik",
    debilitation_degree: 213,
    moolatrikona_sign: "vrishabh",
    moolatrikona_start: 33,
    moolatrikona_end: 60,
    friends: ["sun", "mercury"],
    enemies: [],
    neutrals: ["mars", "jupiter", "venus", "saturn"],
    signifies: ["mind", "mother", "emotions", "fertility", "public", "travel"],
    gemstone: "pearl",
    metal: "silver",
    day: "monday",
    color: "white",
    direction: "northwest",
  },
  {
    id: "mars",
    name_en: "Mars",
    name_hi: "मंगल",
    name_sa: "Mangala",
    swisseph_id: 4,
    nature: "malefic",
    gender: "male",
    element: "fire",
    rules: ["mesh", "vrishchik"],
    exaltation_sign: "makar",
    exaltation_degree: 298,
    debilitation_sign: "kark",
    debilitation_degree: 118,
    moolatrikona_sign: "mesh",
    moolatrikona_start: 0,
    moolatrikona_end: 12,
    friends: ["sun", "moon", "jupiter"],
    enemies: ["mercury"],
    neutrals: ["venus", "saturn"],
    signifies: ["energy", "courage", "siblings", "land", "surgery", "accidents", "anger"],
    gemstone: "red_coral",
    metal: "copper",
    day: "tuesday",
    color: "red",
    direction: "south",
  },
  {
    id: "mercury",
    name_en: "Mercury",
    name_hi: "बुध",
    name_sa: "Budha",
    swisseph_id: 2,
    nature: "neutral",
    gender: "neutral",
    element: "earth",
    rules: ["mithun", "kanya"],
    exaltation_sign: "kanya",
    exaltation_degree: 165,
    debilitation_sign: "meen",
    debilitation_degree: 345,
    moolatrikona_sign: "kanya",
    moolatrikona_start: 165,
    moolatrikona_end: 170,
    friends: ["sun", "venus"],
    enemies: ["moon"],
    neutrals: ["mars", "jupiter", "saturn"],
    signifies: ["intelligence", "communication", "trade", "education", "writing", "skin"],
    gemstone: "emerald",
    metal: "bronze",
    day: "wednesday",
    color: "green",
    direction: "north",
  },
  {
    id: "jupiter",
    name_en: "Jupiter",
    name_hi: "गुरु",
    name_sa: "Guru",
    swisseph_id: 5,
    nature: "benefic",
    gender: "male",
    element: "ether",
    rules: ["dhanu", "meen"],
    exaltation_sign: "kark",
    exaltation_degree: 95,
    debilitation_sign: "makar",
    debilitation_degree: 275,
    moolatrikona_sign: "dhanu",
    moolatrikona_start: 240,
    moolatrikona_end: 250,
    friends: ["sun", "moon", "mars"],
    enemies: ["mercury", "venus"],
    neutrals: ["saturn"],
    signifies: ["wisdom", "children", "wealth", "dharma", "guru", "expansion", "fortune"],
    gemstone: "yellow_sapphire",
    metal: "gold",
    day: "thursday",
    color: "yellow",
    direction: "northeast",
  },
  {
    id: "venus",
    name_en: "Venus",
    name_hi: "शुक्र",
    name_sa: "Shukra",
    swisseph_id: 3,
    nature: "benefic",
    gender: "female",
    element: "water",
    rules: ["vrishabh", "tula"],
    exaltation_sign: "meen",
    exaltation_degree: 357,
    debilitation_sign: "kanya",
    debilitation_degree: 177,
    moolatrikona_sign: "tula",
    moolatrikona_start: 180,
    moolatrikona_end: 195,
    friends: ["mercury", "saturn"],
    enemies: ["sun", "moon"],
    neutrals: ["mars", "jupiter"],
    signifies: ["love", "marriage", "beauty", "art", "luxury", "vehicles", "comfort"],
    gemstone: "diamond",
    metal: "silver",
    day: "friday",
    color: "white",
    direction: "southeast",
  },
  {
    id: "saturn",
    name_en: "Saturn",
    name_hi: "शनि",
    name_sa: "Shani",
    swisseph_id: 6,
    nature: "malefic",
    gender: "neutral",
    element: "air",
    rules: ["makar", "kumbh"],
    exaltation_sign: "tula",
    exaltation_degree: 200,
    debilitation_sign: "mesh",
    debilitation_degree: 20,
    moolatrikona_sign: "kumbh",
    moolatrikona_start: 300,
    moolatrikona_end: 320,
    friends: ["mercury", "venus"],
    enemies: ["sun", "moon", "mars"],
    neutrals: ["jupiter"],
    signifies: ["discipline", "karma", "longevity", "delay", "hardship", "servants", "iron"],
    gemstone: "blue_sapphire",
    metal: "iron",
    day: "saturday",
    color: "blue",
    direction: "west",
  },
  {
    id: "rahu",
    name_en: "Rahu",
    name_hi: "राहु",
    name_sa: "Rahu",
    swisseph_id: 11,
    nature: "malefic",
    gender: "male",
    element: "air",
    rules: [],
    exaltation_sign: "vrishabh",
    debilitation_sign: "vrishchik",
    friends: ["venus", "saturn"],
    enemies: ["sun", "moon", "mars"],
    neutrals: ["mercury", "jupiter"],
    signifies: ["obsession", "foreign", "unconventional", "illusion", "technology", "poison"],
    gemstone: "hessonite",
    metal: "lead",
    day: "saturday",
    color: "smoky",
    direction: "southwest",
    is_shadow_planet: true,
  },
  {
    id: "ketu",
    name_en: "Ketu",
    name_hi: "केतु",
    name_sa: "Ketu",
    swisseph_id: -1,
    nature: "malefic",
    gender: "neutral",
    element: "fire",
    rules: [],
    exaltation_sign: "vrishchik",
    debilitation_sign: "vrishabh",
    friends: ["mars", "jupiter"],
    enemies: ["sun", "moon"],
    neutrals: ["mercury", "venus", "saturn"],
    signifies: ["moksha", "spirituality", "past_life", "detachment", "occult", "surgery"],
    gemstone: "cats_eye",
    metal: "mixed_metals",
    day: "tuesday",
    color: "grey",
    direction: "southwest",
    is_shadow_planet: true,
  },
] as const;

export const planetMap: Readonly<Record<string, Planet>> = Object.fromEntries(
  planets.map((p) => [p.id, p])
);
